/* eslint-disable react/jsx-no-target-blank */
import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useAppDispatch, useAppSelector} from 'src/redux/storeHooks'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {fetchConnectedPlatformAsync, fetchPlatformsAsync} from 'src/redux/actions/platformActions'
import {SidebarMenuItem2} from './SidebarMenuItem2'
import {accessSessionTokenKeyName, loggedInAdminAccessToken, userStaffMenus} from 'src/utils/constants'
import { setTheRangeId } from 'src/redux/slices/productSlice'
import { toAbsoluteUrl } from 'src/marketConnect/helpers'
import SidebarMenuItemForExternalLink from './SidebarMenuItemForExternalLinks'
import { OmsSidebarMenu } from './OmsSidebarMenu'
import { PlatformDataType } from 'src/interfaces/Platform.interface'
import {faHeadset, faHouse,faClipboardList,faWarehouse, faCubes, faSliders, faUsersGear, faDiagramProject, faExchangeAlt, faSlidersH  } from '@fortawesome/free-solid-svg-icons'
import { getURL } from 'src/redux/actions/authActions'
import { useCustomerAccess } from 'src/hooks/useCustomerAccess'
import { useImpersonationSession } from 'src/hooks/useImpersonationSession'
import { useSelector } from 'react-redux'

const formatPlatformTitle = (displayName: string, platformName?: string) => {
  const normalizedDisplay = String(displayName ?? '').trim().toUpperCase()
  const normalizedName = String(platformName ?? '').trim().toUpperCase()
  if (
    normalizedName === 'COMMERCIUMOMS' ||
    normalizedDisplay === 'COMMERCIUMOMS' ||
    normalizedDisplay === 'COMMERCIUM OMS PRODUCTS' ||
    normalizedDisplay.includes('COMMERCIUM OMS')
  ) {
    return 'Master Products';
  }
  return displayName + ' Products';
}

const SidebarMenuMain = () => {
  const {fetchedConnectedPlatformData} = useAppSelector((state) => state.fetchConnectedPlatform)
  const {fetchedUserAccountData, fetchedUserStaffData} = useAppSelector((state) => state.userAccountData)
  const {mainStoreData} = useAppSelector((state) => state.fetchConnectedPlatform)
  // console.log('login data', fetchedConnectedPlatformData)

  const [primaryStorePlatforms, setPrimaryStorePlatforms] = useState([])
  const [secondaryStorePlatforms, setSecondaryStorePlatforms] = useState([])
  const [accountingStorePlatforms, setAccountingStorePlatforms] = useState([])
  const [shippingStorePlatforms, setShippingStorePlatforms] = useState([])
  const [omsStorePlatforms, setOmsStorePlatforms] = useState([])
  const intl = useIntl()
  const dispatch = useAppDispatch()
  const [loader, setLoader] = useState(false)
  const customerAccessControl = useCustomerAccess()
  const { isImpersonating: impersonationSessionActive } = useImpersonationSession()
  const isSuperAdmin =
    fetchedUserAccountData?.is_superuser ||
    fetchedUserAccountData?.user_type === 'SUPERADMIN' ||
    fetchedUserAccountData?.account_type === 'SUPERADMIN'

  const roleName = fetchedUserAccountData?.role?.name?.toLowerCase()
  const roleUserAccess = fetchedUserAccountData?.role?.user_access
  const hasRoleWithAccess =
    !!roleName && !!roleUserAccess && roleUserAccess.toUpperCase() !== 'RESTRICT'
  const hasRoleManagementAccess = isSuperAdmin || hasRoleWithAccess
  const rolePermissions = fetchedUserAccountData?.role
  const customerAccess = rolePermissions?.customer_access
  const reportAccess = rolePermissions?.report_access
  const managePlanAccess = rolePermissions?.manage_plan_access
  const normalizedCustomerAccess = customerAccess?.toUpperCase()
  const normalizedReportAccess = reportAccess?.toUpperCase()
  const normalizedManagePlanAccess = managePlanAccess?.toUpperCase()
  // Hide ALL admin menus when admin logs in as customer (parent_user_role exists)
  // Admin menus should only be visible for direct admin logins, not when impersonating customers
  const isDirectCustomerLogin = fetchedUserAccountData?.user_type === 'USER' && !fetchedUserAccountData?.parent_user_role
  const isLoggedInAsCustomer =
    !!fetchedUserAccountData?.parent_user_role || impersonationSessionActive
  const hideAdminShellMenus = isLoggedInAsCustomer
  
  // Admin menus (Customers, Reports, Custom Plans) - only show for direct admin logins
  const canShowCustomerMenu = !isLoggedInAsCustomer && !isDirectCustomerLogin && (isSuperAdmin || normalizedCustomerAccess === 'SUPERADMIN' || normalizedCustomerAccess === 'WRITE' || normalizedCustomerAccess === 'READ')
  const canShowReportMenu = !isLoggedInAsCustomer && (isSuperAdmin || normalizedReportAccess === 'READ')
  const canShowPlanMenu = !isLoggedInAsCustomer && (isSuperAdmin || normalizedManagePlanAccess === 'WRITE' || normalizedManagePlanAccess === 'READ')
  const shouldRenderAdminMenus = canShowCustomerMenu || canShowReportMenu || canShowPlanMenu
  // let tokenNew = sessionStorage.getItem(`access_token`)
  const isLoginAdminAcess = localStorage.getItem(loggedInAdminAccessToken);
  const IsUserAcess = fetchedUserAccountData?.user_type === 'USER'
  const isUserStaff = fetchedUserAccountData?.parent_user_role && fetchedUserStaffData?.account_type === 'USER_STAFF';
  const parentUserRole = fetchedUserAccountData?.parent_user_role;

  const accountType = fetchedUserAccountData?.account_type;
  // Admin Staff Access
  const adminStaffPcermissions = fetchedUserAccountData?.role?.flow_and_permissions;
  const hasCustomerAccess = adminStaffPcermissions?.customer_access !== "RESTRICT";
  const hasReportAccess = adminStaffPcermissions?.report_access !== "RESTRICT";
  const hasPlanAccess = adminStaffPcermissions?.manage_plan_access !== "RESTRICT";
  const hasUserAccess = adminStaffPcermissions?.user_access !== "RESTRICT";
  const canShowNewsUpdatesMenu =
    !isLoggedInAsCustomer &&
    (isSuperAdmin ||
      accountType === 'SUPERADMIN' ||
      (accountType === 'ADMIN_STAFF' && hasUserAccess))
  const menuList = useSelector((state: any) => state.auth?.menuList ?? []);
  const isOmsStoreAccess = fetchedUserAccountData?.userAdditionalInfo?.platform_connection_priority === "OMS" || false;
  const shouldShowDirectCustomerMenus =
    fetchedUserAccountData?.user_type === 'USER' ||
    (isLoggedInAsCustomer && !isUserStaff)


  useEffect(() => {
    if (localStorage.getItem(accessSessionTokenKeyName)) {
      //for available platform
      // dispatch(fetchPlatformsAsync())

      //for platform
      // dispatch(fetchConnectedPlatformAsync())
    }
  }, [localStorage.getItem(accessSessionTokenKeyName)])

  const getLink = () => {
    setLoader(true)
    dispatch(getURL())
      .then((response) => {
        const redirectUrl = response?.payload?.data?.data?.redirect_url
        if (response?.payload?.data?.status_code === 201 && redirectUrl) {
          window.open(redirectUrl, '_blank')
        }
      })
      .finally(() => setLoader(false))
  }

  useEffect(() => {
    if (fetchedConnectedPlatformData && fetchedConnectedPlatformData.length > 0) {
      
      const omsStore: any = fetchedConnectedPlatformData.filter(
        (platform) => platform.isOmsStore
      )

      const primaryStore: any = fetchedConnectedPlatformData.filter(
        (platform) => platform.isMainStore
      )
       const accountingStore: any = fetchedConnectedPlatformData.filter(
        (platform) => platform.isAccountingStore
      )

         const shippingStore: any = fetchedConnectedPlatformData.filter(
        (platform) => platform.isShippingStore
      )
      const secondaryStore: any = fetchedConnectedPlatformData.filter(
        (platform) => !platform.isMainStore && !platform.isAccountingStore && !platform.isShippingStore && !platform.isOmsStore
      )

            setOmsStorePlatforms(omsStore)
      setPrimaryStorePlatforms(primaryStore)
      setAccountingStorePlatforms(accountingStore)
      setShippingStorePlatforms(shippingStore)
      setSecondaryStorePlatforms(secondaryStore)
    } else {
      setPrimaryStorePlatforms([])
      setAccountingStorePlatforms([])
      setShippingStorePlatforms([])
      setSecondaryStorePlatforms([])
            setOmsStorePlatforms([])
    }
  }, [fetchedConnectedPlatformData])

  const renderUserStaffMenu = (menus) => {
  return menus
    .filter(menu => {
      // -------------------- PERMISSION CHECK --------------------
      if (menu.permissionKey) {
        // Missing key OR restricted → hide
        if (
          !parentUserRole ||
          !(menu.permissionKey in parentUserRole) ||
          parentUserRole[menu.permissionKey] === 'RESTRICT'
        ) {
          return false;
        }
      }

      // -------------------- MODULE CHECK --------------------
      if (menu.moduleCheck) {
        return Boolean(fetchedUserAccountData?.[menu.moduleCheck]);
      }

      return true;
    })
    .map(menu => {
      // -------------------- PRODUCTS MENU --------------------
      // NOTE: permissionKey: 'product_access' MUST be defined in menu config
      if (menu.title === 'Products') {
        // HARD SAFETY CHECK (in case menu config is incorrect)
        if (
          !parentUserRole?.product_access ||
          parentUserRole.product_access === 'RESTRICT'
        ) {
          return null;
        }

        const dynamicChildren: JSX.Element[] = [];

        // Primary Store Products
        primaryStorePlatforms.forEach((platform: PlatformDataType) => {
          dynamicChildren.push(
            <SidebarMenuItem2
              key={`primary-${platform.id}`}
              to={`/listing-product-table/${platform.platform_info?.id}/${platform.id}`}
              title="Source Store Products"
              icon="abstract-16"
              imgSrc={platform.platform_info?.logo_ref}
            />
          );
        });

        // Accounting Store Products
        accountingStorePlatforms.forEach((platform: PlatformDataType) => {
          dynamicChildren.push(
            <SidebarMenuItem2
              key={`accounting-${platform.id}`}
              to={`/listing-product-table/${platform.platform_info?.id}/${platform.id}`}
              title="Accounting Store Products"
              icon="abstract-16"
              imgSrc={platform.platform_info?.logo_ref}
            />
          );
        });

        // Shipping Store Products
        shippingStorePlatforms.forEach((platform: PlatformDataType) => {
          dynamicChildren.push(
            <SidebarMenuItem2
              key={`shipping-${platform.id}`}
              to={`/listing-product-table/${platform.platform_info?.id}/${platform.id}`}
              title="Shipping Store Products"
              icon="abstract-16"
              imgSrc={platform.platform_info?.logo_ref}
            />
          );
        });

        // Secondary Store Products
        secondaryStorePlatforms.forEach((platform: PlatformDataType) => {
          dynamicChildren.push(
            <SidebarMenuItem2
              key={`secondary-${platform.id}`}
              to={`/listing-product-table/${platform.platform_info?.id}/${platform.id}`}
              title={formatPlatformTitle(platform.display_name, platform.name)}
              icon="abstract-16"
              imgSrc={platform.platform_info?.logo_ref}
            />
          );
        });

        const productStaticMenus = [
          { title: 'List Products', to: '/listing-profiles', alternateIcon: faSliders },
          { title: 'Inventory Logs', to: '/inventory-logs', alternateIcon: faWarehouse },
          { title: 'Price Logs', to: '/price-logs', alternateIcon: faWarehouse },
          { title: 'Kits & Bundles', to: '/bundles', alternateIcon: faCubes },
           ...(isOmsStoreAccess ? [
              { title: 'Inventory Adjustment', to: '/inventory-adjustment', alternateIcon: faSlidersH },
              { title: 'Inventory Transfer', to: '/inventory-transfer', alternateIcon: faExchangeAlt },
              { title: 'Custom Fields', to: '/custom-fields', alternateIcon: faDiagramProject },
            ] : [])
        ];

        // Hide Products menu if no children exist
        if (!dynamicChildren.length && !productStaticMenus.length) {
          return null;
        }

        return (
          <SidebarMenuItemWithSub
            key={menu.title}
            title={menu.title}
            icon="cube-2"
            to={menu.to ?? '#'}
          >
            {[
              ...dynamicChildren,
              ...productStaticMenus.map(item => (
                <SidebarMenuItem
                  key={item.title}
                  to={item.to}
                  alternateIcon={item.alternateIcon}
                  title={item.title}
                  requiresSubscription={false}
                />
              )),
            ]}
          </SidebarMenuItemWithSub>
        );
      }

      // -------------------- SALES MENU --------------------
      if (menu.title === 'Sales') {
        const salesChildren = [
          { title: 'Sales Orders', to: '/orders-all', alternateIcon: faClipboardList },
        ];

        return (
          <SidebarMenuItemWithSub
            key={menu.title}
            title={menu.title}
            icon="chart-simple-2"
            to={menu.to ?? '#'}
          >
            {salesChildren.map(item => (
              <SidebarMenuItem
                key={item.title}
                to={item.to}
                alternateIcon={item.alternateIcon}
                title={item.title}
                requiresSubscription={false}
              />
            ))}
          </SidebarMenuItemWithSub>
        );
      }

       // -------------------- TOOLS MENU --------------------
      if (menu.title === 'Tools') {
        return (
          <SidebarMenuItemWithSub key={menu.title} title="Tools" icon="wrench" to={menu.to ?? '/rule-engine'}>
            <SidebarMenuItem 
              key="automation-rules"
              to="/rule-engine"
              alternateIcon={faSliders}
              title="Automation Rules"
              requiresSubscription={false}
            />
          </SidebarMenuItemWithSub>
        );
      }

      // -------------------- NESTED MENU --------------------
      if (menu.children && menu.children.length > 0) {
        const filteredChildren = renderUserStaffMenu(menu.children);

        // Hide parent if all children are filtered out
        if (!filteredChildren || filteredChildren.length === 0) {
          return null;
        }

        return (
          <SidebarMenuItemWithSub
            key={menu.title}
            title={menu.title}
            icon={menu.icon}
            to={menu.to ?? '#'}
          >
            {filteredChildren}
          </SidebarMenuItemWithSub>
        );
      }

      // -------------------- LEAF MENU --------------------
      return (
        <SidebarMenuItem
          key={menu.title}
          to={menu.to}
          alternateIcon={menu.icon}
          title={menu.title}
          requiresSubscription={false}
        />
      );
    })
    .filter(Boolean); // removes nulls safely
};

  const useOmsSidebarPresentation =
    isOmsStoreAccess &&
    (shouldShowDirectCustomerMenus || (isUserStaff && parentUserRole && accountType === 'DIRECT'));

  return (
    <>

      {useOmsSidebarPresentation ? (
        <OmsSidebarMenu
          isUserStaff={Boolean(isUserStaff && parentUserRole && accountType === 'DIRECT')}
          shouldShowDirectCustomerMenus={Boolean(shouldShowDirectCustomerMenus)}
        />
      ) : (
        <>
      { isSuperAdmin || accountType === "DIRECT" && !isUserStaff && (
        shouldShowDirectCustomerMenus ?
        <>
        <SidebarMenuItem
            to='/dashboard'
          alternateIcon={faHouse}
            title={'Dashboard'}
          />

        { (fetchedUserAccountData?.isEnableProductModule || isSuperAdmin) ? 

            <SidebarMenuItemWithSub title='Products' icon='cube-2' to='#'>
              {/* Primary Store Products */}

              {isOmsStoreAccess && omsStorePlatforms.length ? omsStorePlatforms.map((channel: PlatformDataType) => (
                  <SidebarMenuItem2
                    to={`/listing-product-table/${channel.platform_info?.id}/${channel.id}`}
                    key={channel.id}
                    icon='abstract-16'
                    title={formatPlatformTitle(channel.display_name, channel.name)}
                    imgSrc={channel?.platform_info?.logo_ref}
                  />
                )) : null}

              { primaryStorePlatforms.length ? primaryStorePlatforms.map((channel: PlatformDataType) => (
                <SidebarMenuItem2
                  to={`/listing-product-table/${channel.platform_info?.id}/${channel.id}`}
                  key={channel.id}
                  icon='abstract-16'
                  title={`Source Store Products`}
                  imgSrc={channel?.platform_info?.logo_ref}
                />
              )) : null }

                {/* Accounting Store Products */}

              { accountingStorePlatforms.length ? accountingStorePlatforms.map((channel: PlatformDataType) => (
                <SidebarMenuItem2
                  to={`/listing-product-table/${channel.platform_info?.id}/${channel.id}`}
                  key={channel.id}
                  icon='abstract-16'
                  title={`Accounting Store Products`}
                  imgSrc={channel?.platform_info?.logo_ref}
                />
              )) : null }

                {/* Shipping Store Products */}

              { shippingStorePlatforms.length ? shippingStorePlatforms.map((channel: PlatformDataType) => (
                <SidebarMenuItem2
                  to={`/listing-product-table/${channel.platform_info?.id}/${channel.id}`}
                  key={channel.id}
                  icon='abstract-16'
                  title={`Shipping Store Products`}
                  imgSrc={channel?.platform_info?.logo_ref}
                />
              )) : null }

              {/* Secondary Store Products */}

              { secondaryStorePlatforms.length ? secondaryStorePlatforms.map((channel: PlatformDataType) => (
                <SidebarMenuItem2
                  to={`/listing-product-table/${channel.platform_info?.id}/${channel.id}`}
                  key={channel.id}
                  icon='abstract-16'
                  title={formatPlatformTitle(channel.display_name, channel.name)}
                  imgSrc={channel?.platform_info?.logo_ref}
                />
              )) : null }


              {secondaryStorePlatforms.map((platform: any) => {

                if(platform.name==='THERANGEPLUS' && process.env.REACT_APP_ENV === 'staging' ){
                  dispatch(setTheRangeId(platform.id))
                  return(
                      <SidebarMenuItem2
                        to={`/products-files`}
                        key={'csvdn'+ platform.id}
                        title={'CSV Download'}
                        hasBullet
                      />
                    )
                }
              })}

              <SidebarMenuItem
                badge={true}
                to='/listing-profiles'
                icon='questionnaire-tablet'
                title={'List Products'}
              />
              {/* {process.env.REACT_APP_ENV === 'staging' && (
              )} */}
               
            <SidebarMenuItem
            to='/inventory-logs'
            title={'Inventory Logs'}
        alternateIcon={faWarehouse}
          />
           <SidebarMenuItem
            to='/price-logs'
            title={'Price Logs'}
           icon='dollar'
          />
           <SidebarMenuItem
            to='/bundles'
            title={'Kits & Bundles'}
           alternateIcon={faCubes}
          />
           {isOmsStoreAccess && (
                  <>
                    <SidebarMenuItem
                      badge={process.env['REACT_APP_ENV'] == 'production' ? true : false}
                      // badge={true}
                      to='/inventory-adjustment'
                      title={'Inventory Adjusment'}
                      alternateIcon={faSlidersH}
                    />
                    <SidebarMenuItem
                      badge={process.env['REACT_APP_ENV'] == 'production' ? true : false}
                      // badge={true}
                      to='/inventory-transfer'
                      title={'Inventory Transfer'}
                      alternateIcon={faExchangeAlt}
                    />
                    <SidebarMenuItem
                      badge={process.env['REACT_APP_ENV'] == 'production' ? true : false}
                      // badge={true}
                      to='/custom-fields'
                      title={'Custom Fields'}
                      alternateIcon={faDiagramProject}
                    />
                  </>
                )}

            </SidebarMenuItemWithSub>
          : null
        }

     {/* <SidebarMenuItem
            to='/orders-all'
            // title={intl.formatMessage({id: 'MENU.ORDERS'})}
            title={"Sales Order"}
            icon = "handcart"
          />
      */}
       

  <SidebarMenuItemWithSub title='Sales' icon='chart-simple-2' to='/orders-all'>
          <SidebarMenuItem
            to='/orders-all'
            title={intl.formatMessage({id: 'MENU.ORDERS'})}
          alternateIcon={faClipboardList}
          />
        </SidebarMenuItemWithSub>
       
          {/* <SidebarMenuItem
            to='/inventory-logs'
            title={'Inventory'}
           icon='abstract-26'
          /> */}
    

        {/* <SidebarMenuItemWithSub to='/listing-channels' icon='abstract-36' title='Channels'> */}
          <SidebarMenuItem
            to='/listing-channels'
            icon='fasten'
            // hasBullet
            title={'Integrations'}
            // title={intl.formatMessage({id: 'MENU.ADD_MANAGE_CHANNEL'})}
          />

            <SidebarMenuItemWithSub title='Tools' icon='wrench' to='/rule-engine'>
              <SidebarMenuItem
                to='/rule-engine'
                alternateIcon={faSliders}
                title={'Automation Rules'}
              />
            </SidebarMenuItemWithSub>

          {/* <SidebarMenuItem
            to='/rule-engine'
            alternateIcon={faSliders}
            title={'Automation Rules'}
          /> */}

          {fetchedUserAccountData?.source === 'DISCONNECT' && (
            <SidebarMenuItem
              to=''
              title='Discogs Integration'
              icon='abstract-44'
              onClick={getLink}
              badge
              loader={loader}
            />
          )}

        {/* </SidebarMenuItemWithSub> */}
        {/* {
          !fetchedUserAccountData?.isStaffUser  && 
          <SidebarMenuItem
              to='/user-invite'
              icon='people'
              title={'User Management'}
            />
        } */}
          
        {/* {  !fetchedUserAccountData?.isStaffUser && ['SHOPIFY', 'WOOCOMMERCE','ECWID','COMMERCIUM','WIX' ].includes(fetchedUserAccountData?.source!) && (
            <SidebarMenuItem
              badge={ process.env['REACT_APP_ENV'] == 'production' ? true : false }
              to={ mainStoreData?.id ? `/pricing/${mainStoreData?.id}` : '/pricing' }
              icon='dollar'
              title={intl.formatMessage({id: 'MENU.PRICING'})}
            /> 
          )
        } */}

          {/* <SidebarMenuItem
            to='/order-acknowledges'
            icon='bucket'
            title={'Order Acknowledgement'}
          /> */}
          

        <SidebarMenuItem
          to='/support'
          // hasBullet
        alternateIcon={faHeadset}
          title={intl.formatMessage({id: 'SUPPORT'})}
        />
        {/* <SidebarMenuItemForExternalLink
            to='https://commercium.tawk.help/'
            icon='book'
            title={'User Guide'}
        /> */}

          {/* <SidebarMenuItem
            to={`/feature-request`}
            icon='send'
            title={'Feature Request'}
          /> */}
        
      </>
      : null
     )}

     {/* {(isSuperAdmin && fetchedUserAccountData?.user_type !== 'USER') ?
      <>
        <SidebarMenuItemWithSub title='Products' icon='cube-2' to='#'> */}
              {/* Primary Store Products */}

              {/* { primaryStorePlatforms.length ? primaryStorePlatforms.map((channel: PlatformDataType) => (
                <SidebarMenuItem2
                  to={`/listing-product-table/${channel.platform_info?.id}/${channel.id}`}
                  key={channel.id}
                  icon='abstract-16'
                  title={`Source Store Products`}
                  imgSrc={channel?.platform_info?.logo_ref}
                />
              )) : null } */}

                {/* Accounting Store Products */}

              {/* { accountingStorePlatforms.length ? accountingStorePlatforms.map((channel: PlatformDataType) => (
                <SidebarMenuItem2
                  to={`/listing-product-table/${channel.platform_info?.id}/${channel.id}`}
                  key={channel.id}
                  icon='abstract-16'
                  title={`Accounting Store Products`}
                  imgSrc={channel?.platform_info?.logo_ref}
                />
              )) : null } */}

                {/* Shipping Store Products */}

              {/* { shippingStorePlatforms.length ? shippingStorePlatforms.map((channel: PlatformDataType) => (
                <SidebarMenuItem2
                  to={`/listing-product-table/${channel.platform_info?.id}/${channel.id}`}
                  key={channel.id}
                  icon='abstract-16'
                  title={`Shipping Store Products`}
                  imgSrc={channel?.platform_info?.logo_ref}
                />
              )) : null } */}

              {/* Secondary Store Products */}

              {/* { secondaryStorePlatforms.length ? secondaryStorePlatforms.map((channel: PlatformDataType) => (
                <SidebarMenuItem2
                  to={`/listing-product-table/${channel.platform_info?.id}/${channel.id}`}
                  key={channel.id}
                  icon='abstract-16'
                  title={channel.display_name+" Products"}
                  imgSrc={channel?.platform_info?.logo_ref}
                />
              )) : null } */}


              {/* {secondaryStorePlatforms.map((platform: any) => {

                if(platform.name==='THERANGEPLUS' && process.env.REACT_APP_ENV === 'staging' ){
                  dispatch(setTheRangeId(platform.id))
                  return(
                      <SidebarMenuItem2
                        to={`/products-files`}
                        key={'csvdn'+ platform.id}
                        title={'CSV Download'}
                        hasBullet
                      />
                    )
                }
              })} */}

              {/* <SidebarMenuItem
                badge={true}
                to='/template-and-pricing'
                icon='questionnaire-tablet'
                title={'List Products'}
              />
               
            <SidebarMenuItem
            to='/inventory-logs'
            title={'Inventory Logs'}
        alternateIcon={faWarehouse}
          />
           <SidebarMenuItem
            to='/price-logs'
            title={'Price Logs'}
           icon='dollar'
          />
        </SidebarMenuItemWithSub>
      </>
      : null
     } */}

     
      {(isUserStaff && parentUserRole) && accountType === "DIRECT"  &&
  renderUserStaffMenu(userStaffMenus)
}
        </>
      )}

     {(shouldRenderAdminMenus && accountType === "SUPERADMIN" && !hideAdminShellMenus)  ?
      <>
        {canShowCustomerMenu && (
          <SidebarMenuItem
            to='/dashboard'
            icon='abstract-16'
            title={'Customers'}
            requiresSubscription={false}
          />
        )}
        {canShowReportMenu && (
          <SidebarMenuItem
            to='/reports'
            icon='abstract-26'
            title={'Reports'}
            requiresSubscription={false}
          />
        )}
        {canShowPlanMenu && (
          <SidebarMenuItem
            to='/pricing-plans'
            icon='receipt-square'
            title={'Custom Plans'}
            requiresSubscription={false}
          />
        )}
      </>

      : null
     }

       {canShowCustomerMenu && accountType === "USER_STAFF" && !hideAdminShellMenus ?
        <SidebarMenuItem
          to='/customers'
          icon='abstract-16'
          title={'Organization'}
          requiresSubscription={false}
        />
        : null
      }

      {accountType === "ADMIN_STAFF" && !hideAdminShellMenus &&
        <>
          {hasCustomerAccess && (
            <SidebarMenuItem
              to="/dashboard"
              icon="abstract-16"
              title="Customers"
              requiresSubscription={false}
            />
          )}

          {hasReportAccess && (
            <SidebarMenuItem
              to="/reports"
              icon="abstract-26"
              title="Reports"
              requiresSubscription={false}
            />
          )}

          {hasPlanAccess && (
            <SidebarMenuItem
              to="/pricing-plans"
              icon="receipt-square"
              title="Custom Plans"
              requiresSubscription={false}
            />
          )}

          {hasUserAccess && (
            <>
              <SidebarMenuItem
                to="/manage-roles"
                icon="abstract-26"
                title="Manage Roles"
                requiresSubscription={false}
              />
              <SidebarMenuItem
                to="/manage-user"
                icon="abstract-16"
                title="Manage Users"
                requiresSubscription={false}
              />
            </>
          )}
          {canShowNewsUpdatesMenu && (
            <>
              <SidebarMenuItem
                to='/news-updates'
                icon='notification'
                title='News & Updates'
                requiresSubscription={false}
              />
              <SidebarMenuItem
                to='/email-templates'
                icon='sms'
                title='Email Templates'
                requiresSubscription={false}
              />
            </>
          )}
        </>
      }

     { isSuperAdmin && hasRoleManagementAccess && !hideAdminShellMenus ?
      <>
        <SidebarMenuItem
          to='/manage-roles'
          icon='abstract-26'
          title={'Manage Roles'}
          requiresSubscription={false}
        />
        <SidebarMenuItem
          to='/manage-user'
          icon='abstract-16'
          title={'Manage Users'}
          requiresSubscription={false}
        />
        {canShowNewsUpdatesMenu && accountType !== 'ADMIN_STAFF' ? (
          <>
            <SidebarMenuItem
              to='/news-updates'
              icon='notification'
              title={'News & Updates'}
              requiresSubscription={false}
            />
            <SidebarMenuItem
              to='/email-templates'
              icon='sms'
              title={'Email Templates'}
              requiresSubscription={false}
            />
          </>
        ) : null}
      </>
      : null
     }

      {/* {accountType === "DIRECT" && (fetchedUserStaffData?.role?.user_staff_management_access !== "RESTRICT" && IsUserAcess)? 
      <>
        <SidebarMenuItem
          to='/manage-user-roles'
          alternateIcon ={faUsersGear } 
          title={'User Management'}
          requiresSubscription={false}
        />
      </>
      : null
     } */}

      {/* Product management section start */}
      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Management</span>
        </div>
      </div> */}
      {/* <SidebarMenuItem
        to='/products-all'
        icon='abstract-16'
        title={intl.formatMessage({id: 'MENU.ALL_PRODUCT'})}
      /> */}

      {/* <SidebarMenuItem
        to='/inventory-all'
        icon='abstract-25'
        title={intl.formatMessage({id: 'MENU.INVENTORY'})}
      /> */}
      {/* Product management section end  */}

      {/* {clickedPlatform && <ProductsTable selectedPlatform={clickedPlatform} />} */}

      {/* Product management section end  */}

      {/* Custom navigation ends  */}

      {/* Theme navigation start  */}
      {/* <SidebarMenuItem
        to='/dashboard'
        icon='element-11'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      /> */}
      {/* <SidebarMenuItem to='/builder' icon='switch' title='Layout Builder' fontIcon='bi-layers' /> */}
      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Crafted</span>
        </div>
      </div> */}
      {/* <SidebarMenuItemWithSub
        to='/crafted/pages'
        title='Pages'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        <SidebarMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>
          <SidebarMenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
          <SidebarMenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
          <SidebarMenuItem
            to='/crafted/pages/profile/campaigns'
            title='Campaigns'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/documents'
            title='Documents'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/connections'
            title='Connections'
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>

        <SidebarMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}>
          <SidebarMenuItem
            to='/crafted/pages/wizards/horizontal'
            title='Horizontal'
            hasBullet={true}
          />
          <SidebarMenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
        </SidebarMenuItemWithSub>
      </SidebarMenuItemWithSub> */}
      {/* <SidebarMenuItemWithSub
        to='/crafted/accounts'
        title='Accounts'
        icon='profile-circle'
        fontIcon='bi-person'
      >
        <SidebarMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
        <SidebarMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
      </SidebarMenuItemWithSub> */}
      {/* <SidebarMenuItemWithSub to='/error' title='Errors' fontIcon='bi-sticky' icon='cross-circle'>
        <SidebarMenuItem to='/error/404' title='Error 404' hasBullet={true} />
        <SidebarMenuItem to='/error/500' title='Error 500' hasBullet={true} />
      </SidebarMenuItemWithSub> */}
      {/* <SidebarMenuItemWithSub
        to='/crafted/widgets'
        title='Widgets'
        icon='element-7'
        fontIcon='bi-layers'
      >
        <SidebarMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
      </SidebarMenuItemWithSub> */}
      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
        </div>
      </div> */}
      {/* <SidebarMenuItemWithSub
        to='/apps/chat'
        title='Chat'
        fontIcon='bi-chat-left'
        icon='message-text-2'
      >
        <SidebarMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
        <SidebarMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
        <SidebarMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
      </SidebarMenuItemWithSub> */}
      {/* <SidebarMenuItem
        to='/apps/user-management/users'
        icon='abstract-28'
        title='User management'
        fontIcon='bi-layers'
      /> */}
      {/* <div className='menu-item'>
        <a
          target='_blank'
          className='menu-link'
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
        >
          <span className='menu-icon'>
            <KTIcon iconName='code' className='fs-2' />
          </span>
          <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
        </a>
      </div> */}

      {/* Theme navigation ends  */}
    </>
  )
}

export {SidebarMenuMain}

